import { useRxData } from "rxdb-hooks";
import {
  type EpocusReferralQueryConstructor,
  RXDB_EPOCUS_REFERRAL_COLLECTION_NAME,
} from "../../../../global-providers/rxdb-provider/collections/epocus-referral";
import { ALL_VIEWERS, useDemoViewer } from "../../_lib/use-demo-viewer";

/**
 * @param enabled When false (e.g. a role without `viewReferrals`), the query is
 * not fired — oversight roles don't see the Referrals nav item, so its badge
 * count is wasted work for them.
 */
export const useReferralBadgeCount = (enabled = true): number => {
  const viewerId = useDemoViewer();

  const query: EpocusReferralQueryConstructor = (col) => {
    if (!enabled) return undefined;
    return viewerId === ALL_VIEWERS
      ? col?.find({ selector: { status: { $in: ["sent", "acknowledged"] } } })
      : col?.find({
          selector: {
            receivingUserId: { $eq: viewerId ?? "" },
            status: { $in: ["sent", "acknowledged"] },
          },
        });
  };

  const { result } = useRxData(RXDB_EPOCUS_REFERRAL_COLLECTION_NAME, query);
  return result?.length ?? 0;
};
